import UpdateMeditationTranslationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationTranslationRequest";
import AudioFileAlbumTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumTranslationResponse";


export default class MusicTranslateViewModel {
    langCode?: string = '';
	name?: string = '';
    constructor(obj?: Partial<MusicTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): AudioFileAlbumTranslationResponse {
        const res = new UpdateMeditationTranslationRequest({
            LangCode: this.langCode,
            Name: this.name
        });
        return res;
    }
}
